import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import './Temoignages.css';

const Stars = ({ note }) => {
  const full = Math.floor(note);
  const half = note % 1 >= 0.5;
  const stars = [];
  for (let i = 0; i < full; i++) stars.push(<FaStar key={i} className="star star-full" />);
  if (half) stars.push(<FaStarHalfAlt key="half" className="star star-half" />);
  const empty = 5 - full - (half ? 1 : 0);
  for (let i = 0; i < empty; i++) stars.push(<FaRegStar key={`e-${i}`} className="star star-empty" />);
  return <div className="testimonial-stars">{stars}</div>;
};

const Temoignages = () => {
  const { t } = useTranslation();
  const testimonials = t('temoignagesPage.testimonials', { returnObjects: true });

  return (
    <div className="temoignages-page">
      <section className="temoignages-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 text-center">
              <img src="/images/logo.jpeg" alt={t('common.altLogo')} className="hero-logo" />
            </div>
            <div className="col-lg-9 text-center">
              <h1 className="page-title">{t('temoignagesPage.hero.title')}</h1>
              <p className="page-subtitle">{t('temoignagesPage.hero.subtitle')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="temoignages-intro">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <p className="temoignages-intro-text">
                {t('temoignagesPage.intro1')}
                <strong>{t('temoignagesPage.introBold1')}</strong>
                {t('temoignagesPage.intro2')}
                <strong>{t('temoignagesPage.introBold2')}</strong>
                {t('temoignagesPage.intro3')}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="temoignages-content py-5">
        <div className="container">
          <div className="row g-4 justify-content-center">
            {testimonials.map((item, index) => (
              <div key={index} className="col-12 col-sm-6 col-lg-3">
                <article className="testimonial-card testimonial-card-float">
                  <div className="testimonial-card-inner">
                    <Stars note={5} />
                    <p className="testimonial-text">&ldquo;{item.avis}&rdquo;</p>
                    <div className="testimonial-author">
                      <span className="testimonial-initial" aria-hidden="true">{item.prenom.charAt(0)}</span>
                      <span className="testimonial-name">
                        {item.prenom} {item.nom}{' '}
                        <span className="testimonial-pays">({item.pays})</span>
                      </span>
                    </div>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Temoignages;
